import SmoothScroll from './smooth-scroll'
import LocalStorage from './local-storage'
import TwilioPhone from './twilio-phone'
import FCM from './fcm'

class Plugins {
  install (Vue, options) {
    let plugins = {
      storage: new LocalStorage(),
      phone: new TwilioPhone(),
      smoothScroll: new SmoothScroll(),
      fcm: new FCM()
    }
    Vue.prototype.$plugins = plugins
  }
}

export default new Plugins()



// WEBPACK FOOTER //
// ./src/modules/plugins/index.js